import { createContext, useCallback, useContext, useEffect, useState } from "react";

import {
    addNewCar,
    updateCarData,
    getCarData,
    getSomeCars,
    deleteCarData,
    uploadCarImage,
    deleteCarImage,
    processOrder
} from "./products.services";


export const CarContext = createContext();

export const CarContextProvider = ({ children }) => {

    const [allCars, setAllCars] = useState([]);
    const [someCars, setSomeCars] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [showSearch, setShowSearch] = useState(false);
    

    const openSearch = () => {
        setShowSearch(true);
    }

    const closeSearch = () => {
        setShowSearch(false);
    }


    /** increment page */
    const incrementPage = () => {
        setPage((p) => p + 1);
    }

    const decrementPage = () => {
        if (page === 0) return;
        setPage((p) => p - 1);
    }

    /** upload image */
    const uploadImage = async (imageFile) => {
        try {
            setLoading(true);
            const response = await uploadCarImage(imageFile);
            const resp = await response.json();
            return resp;
        } catch (error) {
            return { error }
        } finally {
            setLoading(false);
        }
    }

    /** delete uploaded image */
    const deleteImage = async (imageUrl) => {
        try {
            setLoading(true)
            const response = await deleteCarImage(imageUrl);
            const resp = await response.json();
            return resp;
        } catch (error) {
            return { error }
        } finally {
            setLoading(false);
        }
    }

    /** add car */
    const addNewCarData = async (carData, token) => {
        try {
            setLoading(true);
            const response = await addNewCar(carData, token);
            const resp = await response.json();
            console.log(resp);
            return resp
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    const loadCarById = useCallback( async (id) => {
        if (!id) return;
        try {
            setLoading(true);
            const response = await getCarData(id);
            const carData = await response.json();
            return carData;
        } catch (error) {
            return({error});
        }finally {
            setLoading(false);
        }
    },[]);

   

    const carDelete = async (id, imagesArray, token) => {
        try {
            setLoading(true);
            const delErrors = [];
            imagesArray.forEach(async (imageUri) => {
                const delResponse = await deleteCarImage(imageUri);
                if (delResponse?.error) {
                    delErrors.push(delResponse);
                };
            })
            const response = await deleteCarData(id, token);
            const resp = await response.json();
            return resp;
        } catch (error) {
             return { error }
        }finally {
            setLoading(false);
        }
    }

    /** update car data */
     const updateCar = async (data, id, token) => {
        try {
            setLoading(true);
            const response = await updateCarData(data,id,token);
            const resp = await response.json();
            return resp;
        } catch (error) {
            return { error }
        }finally {
            setLoading(false);
        }
    }

    //send product order
    const sendCarOrder = async (orderData) => {
        try {
            setLoading(true);
            const response = await processOrder(orderData);
            const resp = await response.json();
            return resp;
        } catch (error) {
            return {error}
        }finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        /** get cars by batch */
        const getBatchOfCars = async (page) => {
            try {
                setLoading(true);
                const response = await getSomeCars(page);
                const resp = await response.json();
                return resp;
            } catch (error) {
                return ({error});
            }finally {
                setLoading(false);
            }
        }
        (async () => {
            const data = await getBatchOfCars(page);
            setSomeCars(data?.data);
        })();
    }, [page])

    return (
        <CarContext.Provider
            value={{
                loading,
                allCars,
                someCars,
                showSearch,
                uploadImage,
                addNewCarData,
                deleteImage,
                loadCarById,
                openSearch,
                closeSearch,
                carDelete,
                updateCar,
                sendCarOrder
            }}
        >
            {children}
        </CarContext.Provider>
    )
}

export const UseCarContext = () => useContext(CarContext);